import React, {createContext, useContext, useEffect, useMemo, useState} from "react"
import {Backdrop, CircularProgress} from "@mui/material";
import {boolean} from "property-information/lib/util/types";

export type LoadingContextType = {
    loading: boolean
    setLoading: (value: boolean) => void
}

export const LoadingContext = createContext<LoadingContextType>({
    loading: false,
    setLoading: (value: boolean) => {}
})

export const useLoadingContext = () => useContext(LoadingContext);


export const LoadingContextProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const [loading, setLoading] = useState(false)

    return (
        <LoadingContext.Provider value={{loading, setLoading}}>
            <Backdrop sx={(theme) => ({ color: theme.palette.primary.main, zIndex: theme.zIndex.drawer + 1 })} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {children}
        </LoadingContext.Provider>
    )
}